export const WHATSAPP_MEDIA_MAX_BYTES = 16 * 1024 * 1024;
export const WHATSAPP_CAPTION_MAX = 1024;

export const WHATSAPP_MEDIA_ACCEPT = {
  image: "image/jpeg,image/png,image/webp",
  video: "video/mp4,video/3gpp",
  audio: "audio/ogg,audio/mpeg,audio/mp4,audio/aac,audio/amr,audio/webm,audio/wav",
  document:
    ".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,text/plain,text/csv",
};

const IMAGE_MIMES = new Set(["image/jpeg", "image/png", "image/webp"]);
const VIDEO_MIMES = new Set(["video/mp4", "video/3gpp"]);
const AUDIO_MIMES = new Set([
  "audio/ogg",
  "audio/mpeg",
  "audio/mp4",
  "audio/aac",
  "audio/amr",
  "audio/webm",
  "audio/wav",
  "audio/x-wav",
]);
const DOCUMENT_EXTENSIONS = new Set([
  "pdf",
  "doc",
  "docx",
  "xls",
  "xlsx",
  "ppt",
  "pptx",
  "txt",
  "csv",
]);

const TYPE_LABELS = {
  image: "Photo",
  video: "Video",
  audio: "Audio",
  document: "Document",
};

const ALLOWED_HINT = {
  image: "JPEG, PNG, or WebP",
  video: "MP4 or 3GPP",
  audio: "OGG, MP3, MP4, AAC, or AMR",
  document: "PDF, Office docs, or plain text",
};

function getExtension(name) {
  const parts = String(name || "").toLowerCase().split(".");
  return parts.length > 1 ? parts.pop() : "";
}

export function getWhatsAppMediaTypeLabel(type) {
  return TYPE_LABELS[type] || type;
}

export function validateWhatsAppMediaFile(file, type) {
  if (!file) {
    return { ok: false, error: "Select a file to upload" };
  }

  if (file.size > WHATSAPP_MEDIA_MAX_BYTES) {
    return {
      ok: false,
      error: "File too large (max 16MB)",
    };
  }

  const mime = String(file.type || "").toLowerCase();
  const ext = getExtension(file.name);

  if (type === "image") {
    if (!IMAGE_MIMES.has(mime)) {
      return {
        ok: false,
        error: `File type not allowed. Allowed: ${ALLOWED_HINT.image}`,
      };
    }
    return { ok: true };
  }

  if (type === "video") {
    if (!VIDEO_MIMES.has(mime)) {
      return {
        ok: false,
        error: `File type not allowed. Allowed: ${ALLOWED_HINT.video}`,
      };
    }
    return { ok: true };
  }

  if (type === "audio") {
    if (!AUDIO_MIMES.has(mime) && !["amr", "ogg", "mp3", "m4a", "aac", "wav", "webm"].includes(ext)) {
      return {
        ok: false,
        error: `File type not allowed. Allowed: ${ALLOWED_HINT.audio}`,
      };
    }
    return { ok: true };
  }

  if (type === "document") {
    const docMimeOk =
      mime.startsWith("application/") ||
      mime.startsWith("text/") ||
      mime === "application/pdf";
    const extOk = DOCUMENT_EXTENSIONS.has(ext);
    if (!docMimeOk && !extOk) {
      return {
        ok: false,
        error: `File type not allowed. Allowed: ${ALLOWED_HINT.document}`,
      };
    }
    return { ok: true };
  }

  return { ok: false, error: "Unsupported media type" };
}

export function shouldConvertAudioToVoice(file) {
  const mime = String(file?.type || "").toLowerCase();
  const ext = getExtension(file?.name);
  return (
    mime === "audio/webm" ||
    mime === "audio/wav" ||
    mime === "audio/x-wav" ||
    ext === "webm" ||
    ext === "wav"
  );
}
